module.exports = __webpack_public_path__ + "img/NoiseAware_Quarter_Rest.20b6cf5d.svg";